import * as Sentry from '@sentry/browser';

export function configSentry() {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
  });
}
